<template>
  <div class="customer-edit-profile profile-with-tickets">
    <div class="project-tickets-section">
      <h3>
        {{ constants.TICKETS_CREATED_BY_ME_TEXT }}
      </h3>
      <div class="project-tickets-list">
        <div v-if="createdLoading" class="loading-container">
          <div class="loading-spinner">Loading tickets...</div>
        </div>
        <div v-else>
          <div v-if="createdTickets.length === 0" class="empty-state" style="text-align: center; margin-top: 20px;">
            No ticket is created
          </div>
          <ul v-else>
            <li v-for="issue in createdTickets" :key="issue.id">
              <router-link :to="`/employee/issue-detail/${issue.key}`" id="ticketLink">
                <i>
                  <img :src="issue.fields.issuetype?.iconUrl" alt="" />
                </i>
                <div class="pro-t-l-content">
                  <strong>{{ issue.key }}</strong>
                  <p>{{ issue.fields.summary }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="pagination-box" v-if="createdTotalPages > 1">
        <ul>
          <li class="pagination-first" v-if="createdCurrentPage !== 1" @click="changeCreatedPage(createdCurrentPage - 1)">
            <button id="paginationFirstButton"></button>
          </li>
          <li v-for="page in createdVisiblePages" :key="page" @click="changeCreatedPage(page)">
            <a href="#" :class="{ active: createdCurrentPage === page }">{{ page }}</a>
          </li>
          <li class="pagination-last" v-if="createdCurrentPage !== createdTotalPages" @click="changeCreatedPage(createdCurrentPage + 1)">
            <button id="paginationLastButton"></button>
          </li>
        </ul>
      </div>
    </div>
    <div class="edit-profile-pages">
      <h1>
        {{ constants.EDIT_PROFILE_LINK }}
      </h1>
      <div class="edit-profile-in">
        <div class="edit-profile-in-l">
          <div class="user-pro-img">
            <img :src="displayImage" width="100%" alt="Profile Image" />
          </div>
          <h3>
            {{ fullName }} <span>{{ userProfileData.designation }}</span>
          </h3>
          <ul>
            <li>
              <input
                type="file"
                id="fileUploadInput"
                @change="handleFileUpload"
                accept="image/*"
              /><span>
                {{ constants.UPLOAD_PICTURE_LABEL }}
              </span>
            </li>
            <li>
              <a
                href="javascript:void(0);"
                data-bs-toggle="modal"
                data-bs-target="#deleteProfileimg"
                @click="deleteProfileImage"
              >
                {{ constants.DELETE_PICTURE_LINK }}
              </a>
            </li>
            <li>
              <router-link :to="'/employee/profile'" id="viewProfileLink">
                {{ constants.VIEW_PROFILE_LINK }}
              </router-link>
            </li>
            <li class="active">
              <router-link :to="'/employee/edit-profile'" id="editProfileLink">
                {{ constants.EDIT_PROFILE_LINK }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="edit-profile-in-r">
          <form @submit.prevent="updateProfile">
            <div class="input-row-2">
              <div class="v1-input-field">
                <label>
                  {{ constants.FIRST_NAME_LABEL }}
                </label>
                <input
                  id="firstNameInput"
                  type="text"
                  placeholder="Enter first Name"
                  v-model="userProfileData.firstName"
                />
              </div>
              <div class="v1-input-field">
                <label>
                  {{ constants.LAST_NAME_LABEL }}
                </label>
                <input
                  id="lastNameInput"
                  type="text"
                  placeholder="Enter last Name"
                  v-model="userProfileData.lastName"
                />
              </div>
            </div>
            <div class="input-row-2">
              <div class="v1-input-field">
                <label>
                  {{ constants.EMAIL_ADDRESS_LABEL }}
                </label>
                <input
                  id="emailInput"
                  type="text"
                  placeholder="Enter email address"
                  v-model="userProfileData.email"
                  :readonly="true"
                />
              </div>
              <div class="v1-input-field">
                <label>
                  {{ constants.EDUCATION_LABEL }}
                </label>
                <input
                  type="text"
                  placeholder="Enter education"
                  v-model="userProfileData.education"
                />
              </div>
            </div>
            <div class="input-row-2">
              <div class="v1-input-field">
                <label>
                  {{ constants.COMPANY_NAME_LABEL }}
                </label>
                <input
                  id="companyNameInput"
                  type="text"
                  placeholder="Enter company name"
                  v-model="userProfileData.comapanyName"
                />
              </div>
              <div class="v1-input-field">
                <label>
                  {{ constants.COMPANY_WEBSITE_LABEL }}
                </label>
                <input
                  id="companyWebsiteInput"
                  type="text"
                  placeholder="Enter company website"
                  v-model="userProfileData.websiteUrl"
                />
              </div>
            </div>
            <div class="input-row-2">
              <div class="v1-input-field">
                <label>
                  {{ constants.CONTACT_NO_LABEL }}
                </label>
                <div class="contact-input-group">
                  <input
                    type="tel"
                    id="contact-number"
                    name="contact-number"
                    v-model="userProfileData.contactNumber"
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
              <div class="v1-input-field">
                <label>
                  {{ constants.DEFAULT_ROLE_LABEL }}
                </label>
                <input
                  type="text"
                  placeholder="Enter default role"
                  v-model="userProfileData.designation"
                />
              </div>
            </div>
            <div class="input-row">
              <div class="v1-input-field">
                <label>
                  {{ constants.ABOUT_ME_LABEL }}
                </label>
                <textarea
                  v-model="userProfileData.aboutUs"
                  id="avoutMeInput"
                  class="height-150"
                  placeholder="Enter about me"
                ></textarea>
              </div>
            </div>
            <div id="showclone" class="employee-add-project">
              <div
                id="clone"
                class="input-row-2"
                v-for="(project, index) in userProfileData.projects"
                :key="index"
              >
                <div class="v1-input-field">
                  <label>
                    {{ constants.PROJECT_LABEL }}
                  </label>
                  <select class="v1-selectbox" v-model="project.name">
                    <option value="" disabled selected>Select a project</option>
                    <option
                      v-for="(availableProject, index) in availableProjects"
                      :key="index"
                      :value="availableProject.name"
                    >
                      {{ availableProject.name }}
                    </option>
                  </select>
                </div>
                <div class="v1-input-field">
                  <label>
                    {{ constants.DESIGNATION_LABEL }}
                  </label>
                  <input
                    type="text"
                    placeholder="Enter designation"
                    v-model="project.role"
                  />
                </div>
              </div>
            </div>
            <div class="more-pro-btn">
              <button type="button" id="cloneadd" @click="addMoreProject">
                {{ constants.ADD_MORE_PROJECT_BUTTON }}
              </button>
            </div>
            <div class="input-submit">
              <button
                type="button"
                class="v1-button-outline-black"
                id="cancelBtn"
                @click="resetForm"
              >
                {{ constants.CANCEL_BUTTON }}
              </button>
              <button
                type="submit"
                class="v1-button-outline"
                id="updateBtn"
                :disabled="loading"
              >
                {{ loading ? "Updating..." : constants.UPDATE_BUTTON }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL, API_IMAGES_BASE_URL } from "@/config/api.config";
import Swal from "sweetalert2";
import eventBus from "@/utils/eventBus";

interface Project {
  id: string;
  name: string;
}

interface UserProject {
  id: string;
  name: string;
  role: string;
}

interface AvatarUrls {
  [key: string]: string;
}

interface IssueFields {
  summary: string;
  issuetype: { iconUrl: string };
}

interface Issue {
  id: string;
  key: string;
  fields: IssueFields;
}

export default defineComponent({
  name: "EmployeeEditProfile",
  data() {
    return {
      constants,
      userProfileData: {
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
        designation: "",
        education: "",
        comapanyName: "",
        websiteUrl: "",
        contactNumber: "",
        aboutUs: "",
        avatarUrls: {} as AvatarUrls,
        profileImage: "",
        projects: [] as UserProject[],
      },
      originalUserProfileData: {
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
        designation: "",
        education: "",
        comapanyName: "",
        websiteUrl: "",
        contactNumber: "",
        aboutUs: "",
        avatarUrls: {} as AvatarUrls,
        profileImage: "",
        projects: [] as UserProject[],
      },
      profileImage: "",
      loading: false,
      selectedFile: null as File | null,
      projects: [] as Project[],
      // Tickets created by me
      createdTickets: [] as Issue[],
      createdLoading: false,
      createdCurrentPage: 1,
      createdTotalPages: 0,
      createdLimit: 20,
      createdStart: 0,
    };
  },
  computed: {
    fullName(): string {
      const firstName = this.userProfileData.firstName || "";
      const lastName = this.userProfileData.lastName || "";
      return `${firstName} ${lastName}`.trim() || "User";
    },
    availableProjects() {
      return this.projects;
    },
    displayImage(): string {
      if (this.userProfileData.profileImage) {
        return `${API_IMAGES_BASE_URL}${this.userProfileData.profileImage}`;
      }

      if (
        this.userProfileData.avatarUrls &&
        Object.keys(this.userProfileData.avatarUrls).length > 0
      ) {
        const avatarUrls = this.userProfileData.avatarUrls;
        if (avatarUrls["48x48"]) {
          return avatarUrls["48x48"];
        } else if (avatarUrls["32x32"]) {
          return avatarUrls["32x32"];
        } else {
          return Object.values(avatarUrls)[0] as string;
        }
      }

      return "@/assets/lems-v1/images/default-user-img.jpg";
    },
    createdVisiblePages(): number[] {
      const maxVisiblePages = 5;
      const half = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.createdCurrentPage - half, 1);
      let end = start + maxVisiblePages - 1;
      if (end > this.createdTotalPages) {
        end = this.createdTotalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }
      return Array.from({ length: Math.max(0, end - start + 1) }, (_, i) => start + i);
    },
  },
  async mounted() {
    await this.fetchUserProfile();
    await this.getProjects();

    // Load tickets created by me
    await this.getCreatedTickets();

    eventBus.on(
      "profile-image-delete-confirmed",
      this.performDeleteProfileImage
    );
  },

  beforeUnmount() {
    eventBus.off(
      "profile-image-delete-confirmed",
      this.performDeleteProfileImage
    );
  },
  methods: {
    async fetchUserProfile() {
      try {
        const username = localStorage.getItem("jira_user_username");
        if (!username) {
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/jira/profile/${username}/`
        );

        const userData = response.data.user;
        if (!userData.projects) {
          userData.projects = [];
        }

        if (userData.projects.length === 0) {
          userData.projects.push({
            id: "",
            name: "",
            role: "",
          });
        }

        this.userProfileData = userData;
        this.originalUserProfileData = { ...this.userProfileData };
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load profile data. Please try again.",
        });
      }
    },
    async getProjects() {
      const username = localStorage.getItem("jira_user_username");
      try {
        const response = await axios.get(
          `${API_BASE_URL}/jira/projects/${username}/`
        );
        this.projects = response.data.projects || [];
      } catch (error) {
        console.error("Error fetching projects:", error);
        this.projects = [];
      }
    },
    async updateProfile() {
      try {
        const username = localStorage.getItem("jira_user_username");
        if (!username) {
          return;
        }

        const validProjects = this.userProfileData.projects.filter(
          (project) =>
            project.name &&
            project.name.trim() !== "" &&
            project.role &&
            project.role.trim() !== ""
        );

        const dataToSubmit: any = {
          ...this.userProfileData,
          projects: validProjects,
        };

        if (!this.selectedFile) {
          delete dataToSubmit.profileImage;
        }

        this.loading = true;
        await axios.put(
          `${API_BASE_URL}/jira/profile/${username}/`,
          dataToSubmit
        );

        await this.fetchUserProfile();
        // Emit event to update header
        eventBus.emit("profile-updated");
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile updated successfully",
        });
        this.$router.push("/employee/profile");
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update profile. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.userProfileData = { ...this.originalUserProfileData };
    },
    async handleFileUpload(event: any) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        this.selectedFile = target.files[0];

        try {
          const username = localStorage.getItem("jira_user_username");
          if (!username) {
            return;
          }

          const formData = new FormData();
          formData.append("profileImage", this.selectedFile);

          const response = await axios.put(
            `${API_BASE_URL}/jira/profile/${username}/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          await this.fetchUserProfile();
          // Emit event to update header
          eventBus.emit("profile-updated");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Profile image updated successfully",
          });
        } catch (error) {
          console.error("Error uploading profile image:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to upload profile image. Please try again.",
          });
        } finally {
          this.selectedFile = null;
        }
      }
    },
    deleteProfileImage() {
      // Show the modal using Bootstrap's data attributes
      const modal = document.getElementById("deleteProfileimg");
      if (modal) {
        // Add backdrop and show modal
        const backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade show";
        document.body.appendChild(backdrop);

        modal.classList.add("show");
        modal.style.display = "block";
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("modal-open");
      }
    },

    async performDeleteProfileImage() {
      try {
        const username = localStorage.getItem("jira_user_username");
        if (!username) {
          return;
        }

        const response = await axios.put(
          `${API_BASE_URL}/jira/profile/${username}/`,
          { profileImage: null }
        );
        await this.fetchUserProfile();
        window.location.reload();
        // Emit event to update header
        eventBus.emit("profile-updated");
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile image deleted successfully",
        });
      } catch (error) {
        console.error("Error deleting profile image:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete profile image. Please try again.",
        });
      }
    },
    addMoreProject() {
      this.userProfileData.projects.push({
        id: "",
        name: "",
        role: "",
      });
    },

    async getCreatedTickets() {
      const username = localStorage.getItem("jira_user_username");
      if (!username) return;

      this.createdLoading = true;
      try {
        const params = new URLSearchParams({
          start: this.createdStart.toString(),
          limit: this.createdLimit.toString(),
          filter: 'reported_by_me',
          date_filter: 'all',
        });
        const response = await axios.get(`${API_BASE_URL}/jira/issues/${username}/?${params.toString()}`);
        this.createdTickets = response.data.issues || [];
        this.createdTotalPages = response.data.total_pages || 0;
      } catch (error) {
        console.error('Error fetching created tickets:', error);
        this.createdTickets = [];
        this.createdTotalPages = 0;
      } finally {
        this.createdLoading = false;
      }
    },

    changeCreatedPage(page: number) {
      if (page > 0 && page <= this.createdTotalPages) {
        this.createdCurrentPage = page;
        this.createdStart = (page - 1) * this.createdLimit;
        this.getCreatedTickets();
      }
    },
  },
});
</script>
